import { SmsNotificationsModal } from './SmsNotificationsModal';
import { useLocalStorage } from '@rehooks/local-storage';
import { useFetchedTenantNotificationSettings } from '../hooks/useFetchedTenantNotificationSettings';
import moment from 'moment';
import { useEffect, useState } from 'react';
import useAuth from '../../auth/authContext';

const source = 'ad-hoc';
const daysBetweenReminders = 21;

export const SmsNotificationsPrompt = () => {
  const {
    query: { data: tenantNotificationSettings },
  } = useFetchedTenantNotificationSettings();

  const [now] = useState(new Date());
  const [lastReminded, setLastReminded] = useLocalStorage<string | null>(
    'SmsNotificationsSettings/lastAsked',
    null
  );
  const [originalLastReminded] = useState(lastReminded);

  const {
    state: { user },
  } = useAuth();

  const shouldShowModal =
    (!originalLastReminded ||
      moment(now).subtract(daysBetweenReminders, 'days') > moment(originalLastReminded)) &&
    tenantNotificationSettings &&
    tenantNotificationSettings.smsEnabled === null &&
    user &&
    (user.email.toLowerCase().indexOf('+net30_') < 0 ||
      !user.email.toLowerCase().endsWith('@growegy.com'));

  useEffect(() => setLastReminded(now.toISOString()), [setLastReminded, now]);

  return shouldShowModal ? (
    <SmsNotificationsModal
      source={source}
      isAdhoc={true}
      onClose={() => setLastReminded(new Date().toISOString())}
    />
  ) : null;
};
